"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8735],{

/***/ 69803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ RegionPicker; }
});

// EXTERNAL MODULE: ../../.yarn/cache/tslib-npm-2.3.1-0e21e18015-de17a98d46.zip/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(91806);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(16251);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(98581);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-2f2a2ef1d7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(59802);
// EXTERNAL MODULE: ../../packages/types/dist/ds/index.es.js + 3 modules
var ds_index_es = __webpack_require__(85212);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/assets/images/location.es.js


var locationImg = "https://shopfront-cdn.tekoapis.com/static/f18a4fe05e264d9e.svg";



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(13689);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/components/SelectionOption/SelectionOption.es.js
var SelectionOption_es = __webpack_require__(48992);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/contexts/DeviceContext.es.js
var DeviceContext_es = __webpack_require__(25292);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/components/RegionPicker/RegionPicker.es.js









const RegionPicker = (_a) => {
    var { value, onChange, onSubmit, title, options } = _a, rest = (0,tslib_es6/* __rest */._T)(_a, ["value", "onChange", "onSubmit", "title", "options"]);
    const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
    return ((0,jsx_runtime.jsxs)(Wrapper, Object.assign({}, rest, { children: [(0,jsx_runtime.jsx)("div", Object.assign({ style: { marginBottom: 12, textAlign: 'justify' } }, { children: typeof title === 'string' ? (0,jsx_runtime.jsx)(index_es/* Body */.uT, Object.assign({ level: 1 }, { children: title }), void 0) : title }), void 0), (0,jsx_runtime.jsx)(ImgWrapper, { src: locationImg, alt: "choose location" }, void 0), options.map((el) => {
                return ((0,jsx_runtime.jsx)(StyledSelectionOption, Object.assign({ isActive: value === el.value, onClick: () => {
                        onChange(el.value);
                    }, iconActiveSize: ds_index_es/* SizeEnum.s */.mO.s }, { children: el.text }), el.value));
            }), (0,jsx_runtime.jsx)(Button_es/* Button */.z, Object.assign({ variant: "primary", size: isMobile ? 's' : 'm', block: true, onClick: () => onSubmit(value) }, { children: (0,i18n_es.t)('Xác nhận') }), void 0)] }), void 0));
};
const Wrapper = emotion_styled_browser_esm/* default.div */.Z.div `
  text-align: center;
`;
const ImgWrapper = emotion_styled_browser_esm/* default.img */.Z.img `
  margin: 32px;
`;
const StyledSelectionOption = (0,emotion_styled_browser_esm/* default */.Z)(SelectionOption_es/* SelectionOption */.J) `
  margin-bottom: 4px;
`;




/***/ }),

/***/ 48992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SelectionOption; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91806);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85212);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16251);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59802);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72203);






const MAPPING_ICON_ACTIVE_SIZE = {
    [_teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.xs */ .mO.xs]: 14,
    [_teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.s */ .mO.s]: 14,
};
const MAPPING_ACTIVE_BORDER = {
    [_teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.xs */ .mO.xs]: '0px 24px 24px 0px',
    [_teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.s */ .mO.s]: '0px 24px 24px 0px',
};
const SelectionOption = (_a) => {
    var { children, block = true, isActive = false, onClick, iconActiveSize = _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m, disabled = false } = _a, rest = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, ["children", "block", "isActive", "onClick", "iconActiveSize", "disabled"]);
    const handleClick = () => {
        if (!disabled && typeof onClick === 'function') {
            onClick(!isActive);
        }
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, Object.assign({ isActive: isActive, disabled: disabled, block: block, onClick: handleClick }, rest, { children: [disabled && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OverlayDisabled, {}, void 0), typeof children === 'string' ? ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, Object.assign({ style: { textAlign: 'center' }, level: 1 }, { children: children }), void 0)) : (children), !disabled && isActive && ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActiveBorder, { iconActiveSize: iconActiveSize }, void 0), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Checked, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .CheckOutlined */ .b, { size: MAPPING_ICON_ACTIVE_SIZE[iconActiveSize] || 20, color: "#ffffff" }, void 0) }, void 0)] }, void 0))] }), void 0));
};
const getBorderColor = (props) => {
    return props.isActive ? props.theme.colors.primary500 : '#e0e0e0';
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .Z.div((props) => `
  border-radius: 4px;
  display: inline-block;
  user-select: none;
  border: solid 1px ${getBorderColor(props)};
  background-color: #fff;
  padding: 0.5rem 1.25rem;
  position: relative;
  overflow: hidden;
  cursor: ${props.disabled ? 'not-allowed' : 'pointer'};
  ${props.block ? 'width: 100%;' : ''}

  &:hover {
    background: ${props.isActive || props.disabled ? '' : '#f3f3f3'} ;
  }
`);
const ActiveBorder = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .Z.div(({ iconActiveSize, theme }) => `
  position: absolute;
  top: -1px;
  right: -1px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: ${MAPPING_ACTIVE_BORDER[iconActiveSize] || '0px 36px 36px 0px'};
  border-color: transparent ${theme.colors.primary500} transparent transparent;
`);
const Checked = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* ["default"].span */ .Z.span `
  display: flex;
  position: absolute;
  top: -1px;
  right: -1px;
  z-index: 0;
`;
const OverlayDisabled = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .Z.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #d8d8d852;
  z-index: 1;
`;




/***/ }),

/***/ 13689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(96556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.components.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/lang/en.es.js
var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/i18n.es.js




const NAMESPACE = 'teko-ecommerce';
const t = (keys, options) => {
    const text = i18next/* default.t */.Z.t(keys, Object.assign(Object.assign({}, options), { ns: NAMESPACE }));
    return text || keys;
};
const lang = {
    vi: viLang,
    en: enLang,
};




/***/ }),

/***/ 79945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ButtonChevron; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28697);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75068);






const getTransform = (props) => {
    let style = '';
    switch (props.direction) {
        case 'right':
            style = 'transform: rotate(90deg)';
            break;
        case 'down':
            style = 'transform: rotate(180deg)';
            break;
        case 'left':
            style = 'transform: rotate(-90deg)';
            break;
    }
    return style;
};
const StyledIcon = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l)((props) => `
  transition: transform .2s ease-in-out;
  ${getTransform(props)};
  position: relative;
  margin-left: 2px;
`);
const StyledButton = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z) `
  display: flex;
`;
const Text = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span `
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
`;
const ButtonChevron = (_a) => {
    var { children, direction } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__rest */ ._T)(_a, ["children", "direction"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, Object.assign({}, props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, children),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, { direction: direction, name: "chevron-up", size: 12 })));
};




/***/ }),

/***/ 63940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Dropdown; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22539);





const DropdownWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  width: 100%;
`;
const Dropdown = (_a) => {
    var { children, isOpen, toggle, toggleType = 'click', className, onHide } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, ["children", "isOpen", "toggle", "toggleType", "className", "onHide"]);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!isOpen) {
            return;
        }
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                toggle();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [wrapperRef, isOpen]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .DropdownProvider */ .K, { value: { isOpen, toggle, toggleType } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownWrapper, Object.assign({ onMouseEnter: toggleType === 'hover' ? toggle : null, onMouseLeave: toggleType === 'hover' ? onHide : null, className: className, ref: wrapperRef }, props), children)));
};




/***/ }),

/***/ 22539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ DropdownContext; },
/* harmony export */   "K": function() { return /* binding */ DropdownProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);


const initialState = {
    referenceElement: null,
    toggle: () => { },
    isOpen: false,
    toggleType: '',
};
const DropdownContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(initialState);
const DropdownProvider = ({ children, value }) => {
    const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)((state = initialState, action) => {
        switch (action.type) {
            case 'SET_REFERENCE':
                return Object.assign(Object.assign({}, state), { referenceElement: action.payload });
            default:
                return state;
        }
    }, initialState);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownContext.Provider, { value: { state: Object.assign(Object.assign({}, state), value), dispatch } }, children));
};




/***/ }),

/***/ 22706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ DropdownMenu; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22539);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _Popper_Popper_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73147);





const StyledDiv = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ show, origin }) => `
    background-color: transparent;
    // transition: transform 0.2s, opacity 0.2s;
    // transform: scale(${show ? 1 : 0});
    // transform-origin: ${origin};
    opacity: ${show ? 1 : 0};
  `);
const StyledPopper = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Popper_Popper_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Popper */ .r)(({ show }) => `
    visibility: ${show ? 'visible' : 'hidden'};
    z-index: 999;
  `);
const DropdownMenu = ({ children, popperConfig, placement = 'bottom-start', origin = 'center top', className, }) => {
    const { state: { isOpen, referenceElement }, } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .DropdownContext */ .D);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPopper, { className: className, referenceElement: referenceElement, popperConfig: popperConfig, placement: placement, show: isOpen },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDiv, { show: isOpen, origin: origin }, children)));
};




/***/ }),

/***/ 5123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DropdownToggle; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22539);




const StyledDiv = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  width: 100%;
  &:focus {
    outline: none;
  }
`;
const DropdownToggle = ({ children, className, }) => {
    const [anchor, setAnchor] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const { state: { toggle, toggleType }, dispatch, } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_DropdownContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .DropdownContext */ .D);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        dispatch({ type: 'SET_REFERENCE', payload: anchor });
    }, [anchor]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDiv, { className: className, ref: setAnchor, onClick: toggleType === 'click' ? toggle : null, onKeyUp: toggleType === 'click' ? toggle : null, tabIndex: 0 }, children));
};




/***/ }),

/***/ 73147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Popper; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71316);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);





const Container = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  [data-popper-reference-hidden] {
    visibility: hidden;
    pointer-events: none;
  }
`;
const Popper = (_a) => {
    var { children, referenceElement, className, placement } = _a, _b = _a.popperConfig, _c = _b === void 0 ? {} : _b, { modifiers = [] } = _c, rest = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_c, ["modifiers"]);
    const [popperElement, setPopperElement] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const [arrowElement, setArrowElement] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const { styles, attributes, update } = (0,react_popper__WEBPACK_IMPORTED_MODULE_3__/* .usePopper */ .D)(referenceElement, popperElement, Object.assign({ placement, modifiers: [
            {
                name: 'arrow',
                options: { element: arrowElement },
            },
            {
                name: 'flip',
                enabled: true,
            },
            { name: 'hide' },
            ...modifiers,
        ] }, rest));
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (update) {
            update();
        }
    }, [className]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, Object.assign({ ref: setPopperElement, style: styles.popper }, attributes.popper, { className: className }),
        children,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { ref: setArrowElement, style: styles.arrow })));
};




/***/ }),

/***/ 16037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);
/* harmony import */ var _ButtonChevron_ButtonChevron_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79945);
/* harmony import */ var _Dropdown_Dropdown_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63940);
/* harmony import */ var _Dropdown_DropdownToggle_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5123);
/* harmony import */ var _Dropdown_DropdownMenu_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22706);









const ListItem = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.li */ .z.li(({ selected, theme }) => `
    padding: 0.6rem 0.8rem;
    font-size: 14px;
    background-color: ${selected ? '#f7f7f7' : ''};
    color: ${selected ? theme.brand.primary : 'inherit'};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      background-color: #f7f7f7;
      color: ${theme.brand.primary};
      cursor: pointer;
    }
  `);
const Text = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.span */ .z.span `
  font-size: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  margin-right: 0.25rem;
  text-align: left;
`;
const Content = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.ul */ .z.ul `
  border-radius: 0.25rem;
  border: 1px solid #e0e0e0;
  list-style-type: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  box-shadow: 2px 2px 0.8rem 0 rgba(0, 0, 0, 0.08);
  overflow-y: auto;
`;
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, `
    width: 100%;
`);
const StyledButtonChevron = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_ButtonChevron_ButtonChevron_es_js__WEBPACK_IMPORTED_MODULE_3__/* .ButtonChevron */ .y) `
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: white;
  border-radius: 0.25rem;
  border-color: #e0e0e0;
`;
const StyledDropdown = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_Dropdown_Dropdown_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Dropdown */ .L) `
  width: 100%;
  button {
    ${(p) => p.disabled
    ? `
      background-color: #f8f8fc;
      cursor: not-allowed;`
    : ''}
    > span:first-child {
      flex: 1;
      text-align: left;
    }
  }
`;
const sameWidthModifier = {
    name: 'sameWidth',
    enabled: true,
    phase: 'beforeWrite',
    requires: ['computeStyles'],
    fn: ({ state }) => {
        state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: ({ state }) => {
        state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
    },
};
const dropdownConfigs = {
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [0, 10],
            },
        },
    ],
};
const Select = (_a) => {
    var { title, onChange, items, selectedValue = null, variant, sameWidth = true, disabled = false } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__rest */ ._T)(_a, ["title", "onChange", "items", "selectedValue", "variant", "sameWidth", "disabled"]);
    const [dropdownOpen, setDropdownOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const handleChange = ({ value }) => () => {
        setDropdownOpen(false);
        onChange(value);
    };
    const toggle = () => !disabled && setDropdownOpen((prevState) => !prevState);
    const currentTitle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
        if (selectedValue === null) {
            return title;
        }
        const filteredItems = items.filter(({ value }) => value === selectedValue);
        return filteredItems.length > 0 ? filteredItems[0].content : title;
    }, [items, selectedValue, title]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, Object.assign({}, props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDropdown, { isOpen: dropdownOpen, disabled: disabled, toggle: toggle },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Dropdown_DropdownToggle_es_js__WEBPACK_IMPORTED_MODULE_6__/* .DropdownToggle */ .Z, null,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButtonChevron, { type: "button", direction: dropdownOpen ? 'up' : 'down', variant: variant === 'invalid' ? 'danger' : undefined, outline: true },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, currentTitle))),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Dropdown_DropdownMenu_es_js__WEBPACK_IMPORTED_MODULE_7__/* .DropdownMenu */ .h, { popperConfig: Object.assign(Object.assign({}, dropdownConfigs), { modifiers: [
                        ...dropdownConfigs.modifiers,
                        sameWidth && sameWidthModifier,
                    ] }) },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, null, items.map(({ content, value }, index) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListItem, { onClick: handleChange({ content, value }), selected: value === selectedValue, key: index }, content))))))));
};




/***/ }),

/***/ 49308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ DropDownRegionPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17963);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16037);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12354);





function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 3px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSelect = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Select */ .P)(_templateObject());
var DropDownRegionPicker = function(param) {
    var terminals = param.terminals, onSelectTerminal = param.onSelectTerminal;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), provinces = ref[0], setProvinces = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), districts = ref1[0], setDistricts = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), wards = ref2[0], setWards = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), provinceCode = ref3[0], setProvinceCode = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), districtCode = ref4[0], setDistrictCode = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), wardCode = ref5[0], setWardCode = ref5[1];
    var availCodes = {
        wards: new Set(),
        districts: new Set(),
        provinces: new Set()
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = terminals[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var terminal = _step.value;
            availCodes.wards.add(terminal.location.ward);
            availCodes.districts.add(terminal.location.district);
            availCodes.provinces.add(terminal.location.province);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var locationService = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useServices */ .Su)().locationService;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // get all provinces;
        locationService.getProvinces().then(function(allProvinces) {
            var allowedProvinces = allProvinces.filter(function(province) {
                return availCodes.provinces.has(province.code);
            }).map(function(province) {
                return {
                    content: province.name,
                    value: province.code
                };
            });
            setProvinces(allowedProvinces);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // get list of district when province changes
        if (provinceCode) locationService.getDistrictsByProvinceCode(provinceCode).then(function(allDistricts) {
            var allowedDistricts = allDistricts.filter(function(district) {
                return availCodes.districts.has(district.code);
            }).map(function(district) {
                return {
                    content: district.name,
                    value: district.code
                };
            });
            setDistricts(allowedDistricts);
            setWards([]);
        });
    }, [
        provinceCode
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // get list of wards
        if (districtCode) locationService.getWardsByDistrictCode(districtCode).then(function(allWards) {
            var allowedWards = allWards.filter(function(ward) {
                return availCodes.wards.has(ward.code);
            }).map(function(ward) {
                return {
                    content: ward.name,
                    value: ward.code
                };
            });
            setWards(allowedWards);
        });
    }, [
        districtCode
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSelect, {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)('Chọn tỉnh/th\xe0nh phố'),
                selectedValue: provinceCode,
                onChange: function(code) {
                    if (code !== provinceCode) {
                        setProvinceCode(code);
                        setDistrictCode('');
                        setWardCode('');
                    }
                },
                items: provinces
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSelect, {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)('Chọn quận/huyện'),
                selectedValue: districtCode,
                onChange: function(code) {
                    if (code !== districtCode) {
                        setDistrictCode(code);
                        setWardCode('');
                    }
                },
                items: districts
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSelect, {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)('Chọn phường/x\xe3'),
                selectedValue: wardCode,
                onChange: function(code) {
                    setWardCode(code);
                    // use index is weird, change later
                    if (onSelectTerminal) onSelectTerminal(terminals.findIndex(function(terminal) {
                        return terminal.location.ward === code;
                    }));
                },
                items: wards
            })
        ]
    }));
};


/***/ }),

/***/ 48334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useRegionPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17963);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82957);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43476);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4114);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16251);









var useRegionPicker = function() {
    var ref5;
    var ref1 = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)(), isMobile = ref1.isMobile, originalTerminal = ref1.originalTerminal;
    var terminals = typeof originalTerminal === 'string' ? [] : originalTerminal;
    var selectedTerminal = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL */ .Tp.TERMINAL, isMobile);
    var selectedLocation = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.LOCATION */ .Tp.LOCATION, isMobile);
    var selectedTerminalId = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL_ID */ .Tp.TERMINAL_ID, isMobile);
    var enableLocationFeature = terminals.every(function(item) {
        return !!item.locationCode;
    });
    var confirmedOptionIndex = terminals.findIndex(function(item) {
        if (enableLocationFeature) {
            return item.code === selectedTerminal && item.locationCode === selectedLocation;
        }
        return item.code === selectedTerminal;
    });
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showRegionPopup = ref2[0], setShowRegionPopup = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex), selected = ref3[0], setSelected = ref3[1];
    var onSubmitNewLocation = function() {
        var ref, ref4;
        (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL */ .Tp.TERMINAL, terminals[selected].code, isMobile);
        (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL_ID */ .Tp.TERMINAL_ID, (ref = terminals[selected]) === null || ref === void 0 ? void 0 : (ref4 = ref.id) === null || ref4 === void 0 ? void 0 : ref4.toString(), isMobile);
        enableLocationFeature && (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.LOCATION */ .Tp.LOCATION, terminals[selected].locationCode, isMobile);
         true && window.location.reload();
    };
    var activeLocation = confirmedOptionIndex || confirmedOptionIndex === 0 ? terminals[confirmedOptionIndex] : null;
    var textMsg = "Để ch\xfang t\xf4i c\xf3 thể phục vụ qu\xfd kh\xe1ch tốt hơn, xin qu\xfd kh\xe1ch vui l\xf2ng chọn khu vực m\xecnh sinh sống";
    // temporarily rely on the location object present terminal
    var useDropdownPicker = !!((ref5 = terminals[0]) === null || ref5 === void 0 ? void 0 : ref5.location);
    var locationLabels = useDropdownPicker ? '' : terminals.map(function(item, index) {
        if (index < terminals.length - 1) return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                    children: item.label
                }),
                index === terminals.length - 2 ? ' ' : ', '
            ]
        }, index));
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                ' ',
                (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)('hoặc'),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                    children: item.label
                })
            ]
        }, index));
    });
    var onClosePopup = function() {
        if (activeLocation) {
            setShowRegionPopup(false);
            setSelected(confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex);
        }
    };
    // Luôn mở popup khi chưa chọn địa chỉ giao hàng
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // terminalId is a new key added later
        // we want to deprecate terminalCode
        // so for site without terminalId, prompt region picker
        var isTerminalSelected = !!selectedTerminal && !!selectedTerminalId;
        // add check !activeLocation in case the list of locations changes
        // on server-side, and user
        setShowRegionPopup(enableLocationFeature ? !isTerminalSelected || !selectedLocation || !activeLocation : !isTerminalSelected);
    }, [
        selectedTerminal,
        selectedLocation,
        selectedTerminalId
    ]);
    return {
        showPopup: showRegionPopup,
        setShowPopup: setShowRegionPopup,
        onOpenPopup: function() {
            return setShowRegionPopup(true);
        },
        onClosePopup: onClosePopup,
        selected: selected,
        setSelected: setSelected,
        terminals: terminals,
        locationOptions: terminals.map(function(el, index) {
            return {
                text: el.label,
                value: index
            };
        }),
        onSubmitNewLocation: onSubmitNewLocation,
        activeLocation: activeLocation,
        useDropdownPicker: useDropdownPicker,
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Body */ .uT, {
            level: 1,
            children: [
                textMsg,
                " ",
                locationLabels
            ]
        })
    };
};


/***/ })

}]);